import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FormatDateService {
  private formatSingleDate(date: Date | string | number | null): string | null {
    if (date === null || date === '') {
      return null;
    }

    const dateObj = new Date(date);

    if (isNaN(dateObj.getTime())) {
      throw new Error('Invalid date');
    }

    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  formatDates(data: Record<string, any>): Record<string, any> {
    const formattedData = { ...data };

    for (const [key, value] of Object.entries(formattedData)) {
      if (this.isDateValue(value)) {
        formattedData[key] = this.formatSingleDate(value);
      }
    }

    return formattedData;
  }

  private isDateValue(value: any): boolean {
    if (value instanceof Date) return true;
    if (typeof value === 'string' || typeof value === 'number') {
      const date = new Date(value);
      return !isNaN(date.getTime());
    }
    return false;
  }

  // formatFecha(data: any, campo: string): any {

  //   const fecha = data[campo];

  //   if (fecha) {
  //     const fechaFormateada = this._datePipe.transform(fecha, 'dd/MM/yyyy');
  //     return { ...data, [campo]: fechaFormateada };
  //   }
  //   return data;
  // }

  /**
   * Transforma las fechas especificadas en un arreglo de objetos
   * @param content Arreglo de objetos con datos
   * @param dateFields Arreglo con los nombres de los campos que contienen fechas
   * @returns Arreglo modificado con las fechas transformadas
   */
  public transformDates(content: any[], dateFields: string[]): any[] {
    return content.map((item) => {
      dateFields.forEach((field) => {
        if (item[field]) {
          const date = new Date(item[field]);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          const seconds = String(date.getSeconds()).padStart(2, '0');

          item[field] = `${day}-${month}-${year}, ${hours}:${minutes}:${seconds}`;
        }
      });
      return item;
    });
  }
}
